import { TFunction } from 'i18next'

export interface StatusLabel {
  description: string
  enabled: boolean
  color?: string
}

const pipelineStatusColor = (status: string, t: TFunction) => {
  switch (status) {
    case t('card.pipeline-status.new-contract'):
    case t('card.pipeline-status.contract-sent'):
    case t('card.pipeline-status.contract'):
      return '#8fbc8f'
    case t('card.pipeline-status.emission'):
      return '#008b8b'
    case t('card.pipeline-status.approval'):
      return '#fc783a'
    case t('card.pipeline-status.docs'):
      return '#dd3a33'
    case t('card.pipeline-status.income'):
      return '#4599ee'
    case t('card.pipeline-status.release'):
      return '#fdcccc'
    default:
      return '#778888'
  }
}

const generatePipelineStatusLabel = (
  pipelineStatus: string,
  t: TFunction,
): StatusLabel => ({
  description: pipelineStatus,
  enabled: true,
  color: pipelineStatusColor(pipelineStatus, t),
})

const generateProfessionalStatusLabel = (
  professionalStatus: string,
  t: TFunction,
): StatusLabel => ({
  description: t(`card.loan-info.professional-status.${professionalStatus}`),
  enabled: false,
})

const generateVehicleOwner = (t: TFunction): StatusLabel => ({
  description: t('card.loan-info.no-vehicle-owner'),
  enabled: false,
})

const generateRecurrentLead = (t: TFunction): StatusLabel => ({
  description: t('card.loan-info.recurrent-lead'),
  enabled: false,
})

const fetchStatusLabel = (
  applicationId: string,
  t: TFunction,
  pipelineStatus: string,
  professionalStatus: string,
  vehicleOwner?: string,
  recurrentLead?: boolean,
): StatusLabel[] => {
  let statusLabels: StatusLabel[] = [
    generatePipelineStatusLabel(pipelineStatus, t),
    generateProfessionalStatusLabel(professionalStatus, t),
  ]

  if (!vehicleOwner) {
    statusLabels = [...statusLabels, generateVehicleOwner(t)]
  }

  if (recurrentLead) {
    statusLabels = [...statusLabels, generateRecurrentLead(t)]
  }

  return statusLabels
}

export { fetchStatusLabel }
